import type { RuleType } from './block-rules';

export const cookieCategories: Record<RuleType, string> = {
  strictlyNecessaryCategory: 'C0001',
  performanceCategory: 'C0002',
  functionalCategory: 'C0003',
  targetingCategory: 'C0004',
  socialMediaCategory: 'C0005',
};
